<template>
  <NTab :disabled="isDisabled">
    <template v-if="isEditOrder">
      <OrderForm
        v-bind="props"
        :validate-on-mount="isEditOrder"
        :is-under-writing="isUnderWriting"
      />
    </template>

    <template v-else>
      <NTabs class="w-full mb-1" variant="underline">
        <NTab :title="t('orders.normalOrder')">
          <OrderForm
            v-if="!isOffline"
            v-bind="props"
            :validate-on-mount="isEditOrder"
            :is-under-writing="isUnderWriting"
          />

          <OfflineOrderForm v-else v-bind="props" />
        </NTab>

        <NTab
          v-gid="{
            module: 'order',
            screen: 'home',
            section: 'OrderFormDialog',
            component: 'ConditionalOrderOption',
          }"
          :title="t('orders.conditional.conditionalOrder')"
        >
          <ConditionalForm v-bind="props" />
        </NTab>
      </NTabs>
    </template>
  </NTab>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { Instrument, OrderItem, PortfolioItem } from '@libs/api-reference';
import { useGetOfflineOrderStatusQuery } from '@core/order';

import { OrderForm, ConditionalForm, OfflineOrderForm } from '@/modules/order';

type OrderFormDialogPropsType = {
  model: {
    quantity?: null | number;
    price?: null | number;
  };
  portfolioQuantity: number;
  symbol: Instrument;
  type: 'buy' | 'sell';
  isEditOrder?: boolean;
  selectedOrder?: OrderItem;
  isOrderStatusPending?: boolean;
  isLinkToPrice?: boolean;
  dialogId?: string;
  isUnderWriting?: boolean;
  isDisabled?: boolean;
  bonusShare?: PortfolioItem['bonusShare'];
};

const { t } = useI18n();

const props = defineProps<OrderFormDialogPropsType>();

const { isOffline } = useGetOfflineOrderStatusQuery();
</script>
